
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as agbRHLNd9nF7p9q4RN0GfU9HsI6JvOyS8hv4qXBBKzCm8YMeta } from "/usr/src/app/pages/agb.vue?macro=true";
import { default as indexSOGYUlNekjLExAdmdg47yizum7bBUTQ_u0Ksib56rGsMeta } from "/usr/src/app/pages/shop/index.vue?macro=true";
import { default as requestKbLqgDDCX4hfWga2JJ1U2iOwwFTr5cQtHlXOQFvnbmQMeta } from "/usr/src/app/pages/shop/request.vue?macro=true";
import { default as _91_91id_93_93IWw0TU_5ghqzrNNdTplO4vIILXi_4541A6OrdWX4Jz1mwMeta } from "/usr/src/app/pages/shop/product/[[id]].vue?macro=true";
import { default as _91_91id_93_93V7Ah2FQgigyiAUfOOn5rpXvr8yAun_tqYyixxSHx_xMMeta } from "/usr/src/app/pages/shop/category/[[id]].vue?macro=true";
import { default as shop3SIEqpNACW2rYk75Yl1gbf_k5o40hXlCDt3EiMYXDKIMeta } from "/usr/src/app/pages/shop.vue?macro=true";
import { default as aboutGM5UHk7qsam6f1oSc2Z49RGj4f4aP_rVMkr_45wA6YtokMeta } from "/usr/src/app/pages/about.vue?macro=true";
import { default as adminUsersY_k4Aueg7cyYVpEqZYNoWCOvh4VPrBCGoYwZXta0lGkMeta } from "/usr/src/app/pages/admin/adminUsers.vue?macro=true";
import { default as adminEvents4FrvO6fdjJxeXffU5AJdOvOOib4yF7YLKRz5_450JNBHAMeta } from "/usr/src/app/pages/admin/adminEvents.vue?macro=true";
import { default as userDetailsBj5RuIcX809oyGtw0ckZ2A71uBC_455i5w1OwGIxTVuxwMeta } from "/usr/src/app/pages/admin/userDetails.vue?macro=true";
import { default as eventDetailsrEMbIsPTxhxg1vsb1c8xYKmzz3H4ib1h_y_vF_45uvlYEMeta } from "/usr/src/app/pages/admin/eventDetails.vue?macro=true";
import { default as adminArticlesG1JnuCTk6myftHkBORsRZ43flX9CPKec91EcfeK7W34Meta } from "/usr/src/app/pages/admin/adminArticles.vue?macro=true";
import { default as adminProducts0YqQLq2kIUi5xV84zA_45hl38JkOg_45x12OpkiQ2Y_45oH3AMeta } from "/usr/src/app/pages/admin/adminProducts.vue?macro=true";
import { default as articleDetailsh7dk_rvkoo7tWoGNGaW9YWC7ZKI_45_q_Sw9A5n8T_cJEMeta } from "/usr/src/app/pages/admin/articleDetails.vue?macro=true";
import { default as productDetailsUkTZaPCECszLzJ0wWcD1LKQIUKl3sYGqDXHhM5yB0tUMeta } from "/usr/src/app/pages/admin/productDetails.vue?macro=true";
import { default as admin0k2E5nGQM4pPuzpz_liwe_1ldUQGRP3f7RXh3lgAAmYMeta } from "/usr/src/app/pages/admin.vue?macro=true";
import { default as indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as accountjTFKbZ2nNGMPPqDn9iuMmybrkVNMPrMnjy8JayUz4g4Meta } from "/usr/src/app/pages/account.vue?macro=true";
import { default as contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta } from "/usr/src/app/pages/contact.vue?macro=true";
import { default as plannerKw__6lmNa3LXZlpWoPBt4Q_45U2Hf7F08UxI_DzyhFE_45gMeta } from "/usr/src/app/pages/planner.vue?macro=true";
import { default as privacyu2J_45fpQQL_Dgn_sGlidggdWkxxjogPaqND_45nTe41_csMeta } from "/usr/src/app/pages/privacy.vue?macro=true";
import { default as myEvents_45V5Ch_45DEKVU60g2CZ4z_45y4rk4yfmS7D0ibQg7iP3b_0Meta } from "/usr/src/app/pages/myEvents.vue?macro=true";
import { default as registermVjICC6ssMl1WP_453_45hCWCcFBcUapUwtxJEvEeNH5zCkMeta } from "/usr/src/app/pages/register.vue?macro=true";
import { default as impressumWCM_RKdjWA2Zvzk_vYt6dZz72YV47OyTPSzowa484MAMeta } from "/usr/src/app/pages/impressum.vue?macro=true";
import { default as openhouseNTEJ3OUxxflLd3dk6zXREOTxgJhoKyz9enVZnaXN4n8Meta } from "/usr/src/app/pages/openhouse.vue?macro=true";
import { default as indexb9dLhWKV_hdZEkwDWzx2yuGS_ZBLlFnH6n0WnvGlgNcMeta } from "/usr/src/app/pages/blog/index.vue?macro=true";
import { default as newsletterFl_45DItWdMw7YM9AxTzpHl9KNM5B2bE3mMAUAdztwNBQMeta } from "/usr/src/app/pages/newsletter.vue?macro=true";
import { default as _91_91id_93_93Nd5Y8MzdyToLSFrBJxdMOkAD7LMoz6rAX6wRJ39rIFMMeta } from "/usr/src/app/pages/blog/article/[[id]].vue?macro=true";
import { default as _91_91id_93_93yRhz1vo2WWTCACSDFpSUC_45Kamj0jq2InYB5NEgJ0gisMeta } from "/usr/src/app/pages/blog/category/[[id]].vue?macro=true";
import { default as dj_45set1MEfZ0VvScf_45f4kHYEIvsEbT5YyqZ_45DEaMyDTPwAkpDwMeta } from "/usr/src/app/pages/landingpages/dj-set1.vue?macro=true";
export default [
  {
    name: "agb",
    path: "/agb",
    component: () => import("/usr/src/app/pages/agb.vue")
  },
  {
    name: shop3SIEqpNACW2rYk75Yl1gbf_k5o40hXlCDt3EiMYXDKIMeta?.name,
    path: "/shop",
    component: () => import("/usr/src/app/pages/shop.vue"),
    children: [
  {
    name: "shop",
    path: "",
    component: () => import("/usr/src/app/pages/shop/index.vue")
  },
  {
    name: "shop-request",
    path: "request",
    component: () => import("/usr/src/app/pages/shop/request.vue")
  },
  {
    name: "shop-product-id",
    path: "product/:id?",
    component: () => import("/usr/src/app/pages/shop/product/[[id]].vue")
  },
  {
    name: "shop-category-id",
    path: "category/:id?",
    component: () => import("/usr/src/app/pages/shop/category/[[id]].vue")
  }
]
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/usr/src/app/pages/about.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/usr/src/app/pages/admin.vue"),
    children: [
  {
    name: "admin-adminUsers",
    path: "adminUsers",
    component: () => import("/usr/src/app/pages/admin/adminUsers.vue")
  },
  {
    name: "admin-adminEvents",
    path: "adminEvents",
    component: () => import("/usr/src/app/pages/admin/adminEvents.vue")
  },
  {
    name: "admin-userDetails",
    path: "userDetails",
    component: () => import("/usr/src/app/pages/admin/userDetails.vue")
  },
  {
    name: "admin-eventDetails",
    path: "eventDetails",
    component: () => import("/usr/src/app/pages/admin/eventDetails.vue")
  },
  {
    name: "admin-adminArticles",
    path: "adminArticles",
    component: () => import("/usr/src/app/pages/admin/adminArticles.vue")
  },
  {
    name: "admin-adminProducts",
    path: "adminProducts",
    component: () => import("/usr/src/app/pages/admin/adminProducts.vue")
  },
  {
    name: "admin-articleDetails",
    path: "articleDetails",
    component: () => import("/usr/src/app/pages/admin/articleDetails.vue")
  },
  {
    name: "admin-productDetails",
    path: "productDetails",
    component: () => import("/usr/src/app/pages/admin/productDetails.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/usr/src/app/pages/account.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "planner",
    path: "/planner",
    component: () => import("/usr/src/app/pages/planner.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/usr/src/app/pages/privacy.vue")
  },
  {
    name: "myEvents",
    path: "/myEvents",
    component: () => import("/usr/src/app/pages/myEvents.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/usr/src/app/pages/register.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/usr/src/app/pages/impressum.vue")
  },
  {
    name: "openhouse",
    path: "/openhouse",
    component: () => import("/usr/src/app/pages/openhouse.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/usr/src/app/pages/blog/index.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: () => import("/usr/src/app/pages/newsletter.vue")
  },
  {
    name: "blog-article-id",
    path: "/blog/article/:id?",
    component: () => import("/usr/src/app/pages/blog/article/[[id]].vue")
  },
  {
    name: "blog-category-id",
    path: "/blog/category/:id?",
    component: () => import("/usr/src/app/pages/blog/category/[[id]].vue")
  },
  {
    name: "landingpages-dj-set1",
    path: "/landingpages/dj-set1",
    component: () => import("/usr/src/app/pages/landingpages/dj-set1.vue")
  }
]